import React from 'react';

import { FlexLayout } from '@swyftx/aviary/atoms/Layout/Flex';
import { useFetchShopFaqs } from '@swyftx/features/shop/api/hooks';

import { ShopFaqItemCard } from './ShopFaqItemCard';

type Props = {
  className?: string;
};

const ShopFaq: React.FC<Props> = ({ className }) => {
  const { data } = useFetchShopFaqs();

  return (
    <FlexLayout direction='column' spacing={16} className={className}>
      {data?.faqs?.map((faq) => (
        <ShopFaqItemCard key={faq.id} faqItem={faq} />
      ))}
    </FlexLayout>
  );
};

export { ShopFaq };
